// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__14E1w","itemTitle":"ClientEmergencyInfo_itemTitle__2Bglz","itemText":"ClientEmergencyInfo_itemText__1cYK8"};